<template>
    <div class="form-page">
        <my-form 
            class="form-page" 
            v-model="form" 
            table 
            label-width="180px" 
            :submit-url="`${getGetters('mngUrl')}/revision/FangAn/BiaoDuan/extEdit.json`"
            @cancle="cancleHandler" >
                <el-form-item 
                label="标段名称">
                    {{form.bdname}}
                </el-form-item>

                <el-form-item label="评标时间"  
                    prop="extdate1" 
                    :rules="newRule('评标时间', 'required')">
                        <el-date-picker
                            v-model="form.extdate1"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm"
                            format="yyyy-MM-dd HH:mm"
                            :picker-options="datePickerOptions"
                            default-time="00:00:00">
                        </el-date-picker>
                </el-form-item>

                <el-form-item 
                    label="开标地点"  
                    prop="extstr2" 
                    :rules="newRule('开标地点', 'required')">
                       <el-input v-model="form.extstr2"></el-input>
                </el-form-item>    

                 <el-form-item 
                    label="开标室"  
                    prop="extstr3" 
                    :rules="newRule('开标室', 'required')">
                       <el-input v-model="form.extstr3"></el-input>
                </el-form-item>    

                <el-form-item 
                    label="评标地点"  
                    prop="extstr4" 
                    :rules="newRule('评标地点', 'required')">
                       <el-input v-model="form.extstr4"></el-input>
                </el-form-item>    

                 <el-form-item 
                    label="评标室"  
                    prop="extstr5" 
                    :rules="newRule('开标室', 'required')">
                       <el-input v-model="form.extstr5"></el-input>
                </el-form-item>    
                <template slot="btn" slot-scope="scope">
                    <el-button 
                    @click="saveHandler(1, scope.submitHandler)" 
                    type="primary" 
                    icon="el-icon-circle-check">
                        提交
                    </el-button>
                    <el-button 
                    icon="el-icon-circle-close" 
                    @click="scope.cancleHandler">
                        取消
                    </el-button>
                </template>
        </my-form>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";
export default {
    mixins: [FORM_PAGE_MIXIN],
    data() {
        var that = this
        return{
            form:{
                
            },   
            bdlist:[],
            pblist:[],
            // 开始时间
            datePickerOptions: {
                disabledDate(time) {
                    var today = new Date().pattern('yyyy/MM/dd');
                    return time.getTime() < new Date(today).getTime();
                }
            },
            //结束时间
            pickerOptionsend: {
                disabledDate(time) { //结束时间的禁用
                    var newDate=/\d{4}-\d{1,2}-\d{1,2}/g.exec(that.form.starttime)
                    return time.getTime() <new Date(newDate[0]+ ' 00:00').getTime();
                }
            },     
        }
    },
    computed: {

    },
    watch: {

    },
    methods: {
        saveHandler(type, cb){
            cb && cb();
        }
        
    },
    created() {
        var that = this;
        that.$get(`${that.getGetters('mngUrl')}/revision/FangAn/BiaoDuan/extEdit`, {
            procode:that.getQuery('procode'),
            bdcode:that.getQuery('bdcode'),
        }, data => {
            that.form = data.model;
            that.form.bdname = data.bdModel.bdname;
        });
    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">

</style>
